import React from 'react';
import styled from 'styled-components';
import { siteConfig } from '../../config/site';

const Section = styled.section` padding: 5rem 1rem; background: var(--background-dark); `;
const Inner = styled.div` max-width: 1200px; margin: 0 auto; `;

const Head = styled.div`
  text-align: center; max-width: 720px; margin: 0 auto 3rem;
  .tag {
    display: inline-block;
    padding: 0.35rem 0.9rem; border-radius: 999px;
    border: 1px solid rgba(255,255,255,0.15);
    background: rgba(0,153,0,0.08); color: var(--primary-color);
    font-size: 0.75rem; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase;
    margin-bottom: 1rem;
  }
  h2 { font-size: clamp(1.75rem, 3.2vw, 2.5rem); margin: 0 0 0.75rem; color: var(--text-color); span { color: var(--primary-color); } }
  p { color: var(--text-secondary); line-height: 1.7; margin: 0; }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  @media (max-width: 900px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 600px) { grid-template-columns: 1fr; }
`;

const Card = styled.article`
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(0, 153, 0, 0.15);
  border-radius: var(--border-radius);
  padding: 1.75rem;
  transition: transform 0.25s ease, border-color 0.25s ease;
  &:hover { transform: translateY(-4px); border-color: var(--primary-color); }
  .icon {
    display: inline-flex; align-items: center; justify-content: center;
    width: 44px; height: 44px; border-radius: 12px;
    background: rgba(0, 153, 0, 0.12); color: var(--primary-color);
    font-size: 1.4rem; margin-bottom: 1rem;
  }
  h3 { font-size: 1.1rem; margin: 0 0 0.5rem; color: var(--text-color); }
  p { color: var(--text-secondary); margin: 0; line-height: 1.6; font-size: 0.95rem; }
`;

const PERSONAS = [
  { icon: '📈', title: 'Traders & Investors', desc: 'Rehearse P2P and OTC USDT trades, and preview flash liquidity on wallets before a real transfer.' },
  { icon: '🧪', title: 'Crypto Enthusiasts', desc: 'Explore USDT wallet flows, network switching and flash transaction UIs without touching real funds.' },
  { icon: '🚀', title: 'Businesses & Startups', desc: 'Demo USDT payment flows and UX to stakeholders before wiring up live payment rails.' },
  { icon: '🎮', title: 'Betting & Gaming Platforms', desc: 'Stress-test USDT deposit and confirmation flows against realistic flash balances before launch.' },
  { icon: '🧩', title: 'DeFi Teams', desc: 'Validate dApp and wallet integrations across TRC-20, ERC-20 and BEP-20 flash USDT without mainnet risk.' },
  { icon: '🏛️', title: 'Institutions', desc: 'Run internal training and compliance walkthroughs at enterprise scale with USDT flash validity windows.' },
];

const Audience: React.FC = () => (
  <Section id="audience">
    <Inner>
      <Head>
        <div className="tag">Who it's for</div>
        <h2>The <span>flash USDT store</span> for every USDT workflow</h2>
        <p>From solo traders to enterprise teams — {siteConfig.brand.name} scales to fit how you work.</p>
      </Head>
      <Grid>
        {PERSONAS.map((p) => (
          <Card key={p.title}>
            <div className="icon" aria-hidden="true">{p.icon}</div>
            <h3>{p.title}</h3>
            <p>{p.desc}</p>
          </Card>
        ))}
      </Grid>
    </Inner>
  </Section>
);

export default Audience;
